module.exports = __webpack_public_path__ + "static_pc/img/bannerBg.c61dc06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/bannerBg.jpg
// module id = ZCfp
// module chunks = 1